module.exports = __webpack_public_path__ + "img/tv_fukidashi.9fba3846.svg";